export const INDOOR = 'indoor';
export const BASE_STATION = 'base_station';
export const ONVIF_DEVICE_TYPE = 'onvif_camera';
export const E2EE_DEVICE_TYPE = 'e2ee';
export const RECORDING_24X7_DEVICE_TYPE = '24x7';
export const ASTRO_ELEGIBLE_INFO = 'astro-sub';
export const ASTRO_DEVICE_INTERNAL_TYPE = 'astro';
export const ASTRO_DEVICE_TYPE = 'three_p_cam';
export const ASTRO_DEVICE_MODEL = 'A2MDL5WTJIU8SZ';
